/**
 * JoinARJoinPageView
 *
 * Page component for JoinARJoinPageView
 * Path: /ar/join
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { JoinARJoinPageView as __JoinARJoinPageView } from '@/components/traits/JoinARJoinPageView';
import { JoinARJoinAnalyticsView as __JoinARJoinAnalyticsView } from '@/components/traits/JoinARJoinAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';
import { ToastSlot } from '@almadar/ui/components';

interface JoinARJoinPageViewProps {
  // Add any page-level props here
}

export function JoinARJoinPageView(_props: JoinARJoinPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-join:meta.title"],"description":["i18n/t","std-almadar-join:meta.description"],"access":"public","indexing":"noindex","origin":"https://almadar.io","siteName":"Almadar", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__JoinARJoinPageView config={{ initPayload: __navState }} />
          <__JoinARJoinAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default JoinARJoinPageView;
